<template>
  <v-dialog v-model="show" max-width="500px">
    <v-card>
      <v-card-title>Generate Lease Agreement</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-4">
        <p>
          <strong>Asset:</strong> {{ asset.Brand }} {{ asset.Model }} (SN: {{ asset.Serial_Number }})
        </p>

        <p v-if="asset.Employee_ID">
          <strong>For Employee:</strong> {{ asset.Full_Name }}
        </p>
        <p v-else class="red--text">
          <strong>This asset is not assigned to an employee.</strong>
        </p>

        <v-text-field
          v-model="assetValue"
          label="Asset Value (for document)"
          prefix="₴"
          type="number"
        ></v-text-field>

      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="show = false">Cancel</v-btn>
        <v-btn
          color="primary"
          :disabled="!asset.Employee_ID || !assetValue"
          @click="generateDocument"
        >
          Generate
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AssetsLeaseDialog',
  props: {
    value: { type: Boolean, required: true },
    asset: { type: Object, required: true }
  },
  data () {
    return {
      assetValue: null
    }
  },
  computed: {
    show: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    }
  },
  methods: {
    generateDocument () {
      this.$emit('generate', {
        assetId: this.asset.Asset_ID,
        employeeId: this.asset.Employee_ID,
        assetValue: this.assetValue
      })
      this.show = false
    }
  }
}
</script>
